"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminDrawOrderContract = void 0;
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.adminDrawOrderContract = c.router({
    getTicketsForPlayer: {
        method: 'GET',
        path: '/ticket/player/:player_id',
        pathParams: zod_1.z.object({
            player_id: zod_1.z.string(),
        }),
        query: zod_1.z.object({
            drawTypeCode: zod_1.z.optional(zod_1.z.string()),
            drawTypeCodes: zod_1.z.string().array().optional(),
            drawTypeGroup: zod_1.z.optional(zod_1.z.string()),
            excludeCompleted: zod_1.z.optional(utils_1.booleanParamSchema),
        }),
        responses: {
            200: zod_1.z.array(models_1.ZTicketDetails),
            404: c.type(),
        },
    },
    cancelTicket: {
        method: 'POST',
        path: '/ticket/:ticket_id/cancel',
        pathParams: zod_1.z.object({
            ticket_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            reason: zod_1.z.string(),
        }),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    awardFreeEntries: {
        method: 'POST',
        path: '/award-free-entries',
        body: models_1.ZAwardFreeEntriesRequest,
        responses: {
            200: utils_1.successSchema,
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Award free entries to player',
    },
    getDrawTickets: {
        method: 'GET',
        path: '/draw/:draw_id/tickets',
        pathParams: zod_1.z.object({
            draw_id: zod_1.z.coerce.number(),
        }),
        query: zod_1.z.object({
            drawTypePlanCode: zod_1.z.optional(zod_1.z.string()),
            drawTypePlanSubCode: zod_1.z.optional(zod_1.z.string()),
        }),
        responses: {
            200: zod_1.z.array(zod_1.z.object({
                entryId: zod_1.z.string(),
                purchaseDate: zod_1.z.coerce.date(),
                numbers: dbJsonModels_1.ZEntryLine,
            })),
            404: c.type(),
        },
    },
    getDrawTicketsAsCsv: {
        method: 'GET',
        path: '/draw/:draw_id/tickets/csv',
        pathParams: zod_1.z.object({
            draw_id: zod_1.z.coerce.number(),
        }),
        query: zod_1.z.object({
            drawTypePlanCode: zod_1.z.optional(zod_1.z.string()),
            drawTypePlanSubCode: zod_1.z.optional(zod_1.z.string()),
        }),
        responses: {
            200: zod_1.z.string(),
            404: c.type(),
        },
    },
}, {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=drawOrder.admin.contract.js.map